import { LoadingButton } from "@mui/lab";
import { Box, Button, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import {
  FormProvider,
  RHFCheckbox,
  RHFTextField,
} from "src/components/hook-form";
import Password from "src/components/Password";
import useLocales from "src/hooks/useLocales";
import { PATH_AUTH } from "src/routes/paths";
import AuthHelper from "./components/authHelper";
import ErrorBanner from "./components/errorBanner";
import useLogin from "./hooks/useLogin";

const LoginForm = () => {
  const { methods, onSubmit, onSubmitCode, twoFactorRequired, cancelTwoFactor } =
    useLogin();
  const { translate } = useLocales();

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  console.log('[LoginForm] Render - Current URL:', window.location.href);

  const handleFormSubmit = (data) => {
    console.log('[LoginForm] handleFormSubmit called with data:', data);
    console.log('[LoginForm] URL at submit time:', window.location.href);
    return onSubmit(data);
  };

  // Secondo passo della verifica in due passaggi: al posto di email+password
  // si chiede il codice. La password NON viene ripetuta (il challenge emesso
  // dal primo passo identifica gia' l'utente e scade in 5 minuti).
  if (twoFactorRequired) {
    return (
      <FormProvider methods={methods} onSubmit={onSubmitCode}>
        <Stack spacing={2} sx={{ mb: 3 }}>
          <ErrorBanner />
        </Stack>

        <Box>
          <Typography variant="h6" sx={{ mb: 1 }}>
            {translate("auth.login.twoFactorTitle")}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
            {translate("auth.login.twoFactorSubtitle")}
          </Typography>

          <RHFTextField
            name="code"
            autoComplete="one-time-code"
            autoFocus
            label={translate("auth.login.twoFactorCodeLabel")}
            showSuccessAdornment={false}
          />

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            name="twofa-verify"
            sx={{ mt: 2 }}
          >
            {translate("auth.login.twoFactorSubmit")}
          </LoadingButton>

          <Button fullWidth sx={{ mt: 1 }} onClick={cancelTwoFactor}>
            {translate("auth.login.twoFactorBack")}
          </Button>
        </Box>
      </FormProvider>
    );
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(handleFormSubmit)}>
      <Stack spacing={2} sx={{ mb: 3 }}>
        <AuthHelper />
        <ErrorBanner />
      </Stack>

      <Box>
        <Stack spacing={2}>
          <RHFTextField
            name="email"
            type="email"
            autoComplete="email"
            label={translate("auth.login.emailLabel")}
            showSuccessAdornment={false}
          />
          <Password
            name="password"
            autoComplete="current-password"
            label={translate("auth.login.passwordLabel")}
            showSuccessAdornment={false}
          />
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ my: 2 }}
        >
          <RHFCheckbox name="remember" label={translate("auth.login.rememberMe")} />
          <Link
            component={RouterLink}
            variant="subtitle2"
            to={PATH_AUTH.resetPassword}
          >
            {translate("auth.login.forgotPassword")}
          </Link>
        </Stack>

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          name="login"
        >
          {translate("auth.login.submit")}
        </LoadingButton>
      </Box>
    </FormProvider>
  );
};

export default LoginForm;
